import xhr from 'xhr';

export default {
  name: 'api',

  getReducer: () => {
    const initialState = {
      root: process.env.REACT_APP_CM_ENV
    }

    return (state = initialState, { type, payload }) => {
      return state;
    }
  },

  selectApiRoot: (state) => {
    return state.api.root;
  },

  getExtraArgs: (store) => {

    return {
      anonGet: (path, callback) => {
        const options = {
          url: path
        }
        xhr.get(options, callback)
      },

      apiGet: (path, callback) => {
        const token = store.selectTokenRaw();
        const options = {
          url: path
        }
        if(token){
          options.headers = {
            Authorization: "Bearer " + token
          }
        }
        xhr.get(options, callback)
      },

      apiPost: (path, payload, callback) => {
        const token = store.selectTokenRaw();
        const options = {
          url: path,
          json: payload
        }
        if(token){
          options.headers = {
            Authorization: "Bearer " + token,
            'Content-Type': 'application/json'
          }
        }
       
        xhr.post(options, callback)
      },

      apiDel: (path, callback) => {
        const token = store.selectTokenRaw();
        const options = {
          url: path
        }
        if(token){
          options.headers = {
            Authorization: "Bearer " + token
          }
        }
        xhr.del(options, callback)
      } 
    }
  }
}